﻿namespace eXpress.core {
	export interface IPhotoStoreConnectorDependencies {
		readonly storageService: services.StorageService;
		readonly connectedToStoreAsync: (store: IPhotoStore | null) => Promise<void>;
	}

	export class PhotoStoreConnector {
		private storageService: services.StorageService;
		private connectedToStoreAsync: (store: IPhotoStore | null) => Promise<void>;
		private partnerWindow: Window | null = null;
		private broadcastChannel: BroadcastChannel;

		constructor(deps: IPhotoStoreConnectorDependencies) {
			this.storageService = deps.storageService;
			this.connectedToStoreAsync = deps.connectedToStoreAsync;
		}

		public async connectToAsync(store: IPhotoStore, requireHasAlbumAccessCheck = true): Promise<void> {
			if (store.isConnected && (store.hasAlbumAccess || !requireHasAlbumAccessCheck)) {
				this.connectedToStoreAsync(store);
				return;
			}

			if (store instanceof partners.PartnerStore)
				this.connectToPartnerStore(<partners.PartnerStore>store);
			else
				await this.connectToSmartphotoStoreAsync(<core.ExpressStore>store);
		}

		private connectToSmartphotoStoreAsync = async (store: core.ExpressStore): Promise<void> => {
			core.showLoadingDialogAsync(LoginPopup.createDialogAsync(true))
				.then($popup => new LoginPopup($popup).openAsync())
				.then(async (loginResult) => {
					if (!loginResult)
						return this.connectedToStoreAsync(null);
					store.isConnected = true;
					store.hasAlbumAccess = true;
					store.connectedUserName = loginResult.accountName;
					await this.connectedToStoreAsync(store);
				});
		};

		private connectToPartnerStore = (store: core.partners.PartnerStore): void => {
			const url = store.locatePhotosUrl + "?inpopup";
			const windowSize = html.getWindowSize();

			// create and listen on a broadcastChannel
			this.broadcastChannel = new BroadcastChannel("connectedToStorePartner");
			this.broadcastChannel.onmessage = this.connectedToStorePartnerAsync;

			// open login window of partner
			if (this.partnerWindow === null || this.partnerWindow.closed)
				this.partnerWindow = window.open(url, "partnerWindow", `left=${windowSize.width > 1200 ? (windowSize.width - 1200) / 2 : 0},top=0,height=${windowSize.height},width=1200,status=no,toolbar=no,menubar=no,location=no,resizable=yes,scrollbars=yes`);
			else
				this.partnerWindow.focus();
		};

		private connectedToStorePartnerAsync = async (event) => {
			//Close the channel
			if (this.broadcastChannel)
				this.broadcastChannel.close();

			if (!event.data)
				return;

			if (event.data.command == 'ImportPhotosPopUpError') {
				const bc = new BroadcastChannel("connectedToStorePartner");
				bc.postMessage({
					command: "ImportPhotosPopUpError",
					detail: event.data.detail,
				});
				return;
			}

			if (event.data.command !== 'ConnectedToStorePartner')
				return;

			const storeType: eXpress.core.StoreType = event.data.storeType;
			if (!storeType) {
				await this.connectedToStoreAsync(null);
			}

			const photoStores = await this.storageService.getPhotoStoresAsync(context.pointOfSaleId, context.languageCode);
			const selectedstore = photoStores ? utils.findFirst(photoStores, s => s.storeType === storeType) : null;
			await this.connectedToStoreAsync(selectedstore ?? null);
		};
	}
}
